import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fill-right",
  "use": "icon-fill-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fill-right\">\n<g id=\"icon-fill-right_Direction/fill-right\">\n<g id=\"icon-fill-right_Frame 4\">\n<path id=\"icon-fill-right_Polygon 2\" d=\"M10.5391 7.61589C10.7789 7.81579 10.7789 8.18421 10.5391 8.38411L5.82009 12.3166C5.49443 12.588 5 12.3564 5 11.9325L5 8L5 4.06752C5 3.6436 5.49443 3.41202 5.82009 3.68341L10.5391 7.61589Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fill-right.svg
// module id = 0Mgb
// module chunks = 140